<template>
  <section class="flex flex-col md:flex-row pt-10 pb-3 md:py-10 gap-10">
    <div class="w-full md:w-1/2">
      <UtilsSkeletonLoading class="w-40 h-8" />
      <div class="detail-title mt-7">
        <UtilsSkeletonLoading class="w-full h-20 mb-5" />
        <div class="flex flex-col mt-2 mb-5 gap-2">
          <UtilsSkeletonLoading class="w-16 h-8" />
          <UtilsSkeletonLoading class="w-32 h-8" />
        </div>
        <div v-for="i in 2" :key="i" class="flex mt-2 gap-2">
          <UtilsSkeletonLoading class="w-16 h-8" />
          <UtilsSkeletonLoading class="w-32 h-8" />
        </div>
      </div>
    </div>

    <div class="w-full md:w-1/2 flex items-center relative">
      <UtilsSkeletonLoading class="w-full h-60 md:h-80" />
    </div>
  </section>
</template>

<script setup></script>

<style lang="scss" scoped></style>
